import { useQuery } from '@tanstack/react-query';
import { useAtom } from 'jotai';
import { useEffect } from 'react';

import { getApplicantId, getGraduateInfo } from '@/api/v2/graduate';
import { onlineUserIdAtom } from '@/store/user';

export const useGraduateInfo = (applicantId: string) => {
  const response = useQuery({
    queryKey: ['graduateInfo', applicantId],
    queryFn: () => getGraduateInfo(applicantId),
    staleTime: Infinity,
    gcTime: Infinity,
  });

  useEffect(() => {
    if (response.data?.status) {
      alert(
        '수료 정보를 가져오는 데 실패했습니다! 매니저에게 연락 부탁드립니다.',
      );
    }
  }, [response.data?.status]);

  return response;
};

export const useApplicantId = (round: string) => {
  const [onlineUserId] = useAtom(onlineUserIdAtom);
  const response = useQuery({
    queryKey: ['graduateApplicantId', onlineUserId],
    queryFn: () => getApplicantId(onlineUserId, round),
    enabled: onlineUserId !== '',
    staleTime: Infinity,
    gcTime: Infinity,
  });
  return response;
};
